import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ShieldCheckIcon } from "@heroicons/react/24/outline";

function AdminLogin({ setIsAuthenticated }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [focused, setFocused] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });

      if (!response.ok) {
        throw new Error("Invalid password");
      }

      setIsAuthenticated(true);
      navigate("/admin");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 flex items-center justify-center pt-32 pb-12 px-4 text-white">
      <div className="w-full max-w-md">
        {/* Header */}
        <div className="text-center mb-12 animate-fade-in">
          <Link to="/" className="inline-block mb-6">
            <img
              src="/imgs/logo-white.png"
              alt="Ingersoll Built Logo"
              className="h-20 hover-card"
            />
          </Link>
          <div className="inline-flex items-center gap-2 mb-4 px-4 py-2 bg-white bg-opacity-10 border border-white border-opacity-20 rounded-full text-sm text-cyan-300 animate-bounce-gentle">
            <ShieldCheckIcon className="w-4 h-4" />
            Secure Area
          </div>
          <h1 className="text-4xl font-bold text-white mb-3">
            Admin{" "}
            <span className="bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
              Access
            </span>
          </h1>
          <p className="text-gray-300">Enter your password to continue</p>
        </div>

        {/* Login Card */}
        <div className="bg-white bg-opacity-5 border border-white border-opacity-10 rounded-2xl backdrop-blur-sm p-8 mb-6 animate-slide-in-right hover-card">
          {error && (
            <div className="mb-6 p-4 bg-red-500 bg-opacity-20 border border-red-500 border-opacity-30 rounded-lg text-red-200 text-sm animate-fade-in">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <label className="block text-white font-semibold mb-3 text-sm">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                placeholder="Enter admin password"
                required
                className={`w-full px-4 py-3 bg-white bg-opacity-10 border rounded-lg text-white placeholder-gray-400 focus:outline-none transition-all duration-300 ${
                  focused
                    ? "border-cyan-400 shadow-lg shadow-cyan-500/20"
                    : "border-white border-opacity-20 hover:border-gray-400"
                }`}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-blue-600 to-cyan-500 text-white font-bold py-3 px-4 rounded-lg hover:shadow-2xl hover:shadow-cyan-500/30 transform hover:scale-105 transition-all duration-300 disabled:opacity-50 disabled:scale-100"
            >
              {loading ? "Logging in..." : "Login →"}
            </button>
          </form>
        </div>

        {/* Back Link */}
        <div
          className="text-center animate-fade-in"
          style={{ animationDelay: "0.15s" }}
        >
          <Link
            to="/"
            className="text-gray-300 hover:text-cyan-400 transition text-sm font-medium"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
